import type { PropsWithChildren, ReactNode } from 'react';

import Error404 from '@/components/errors/Error404';
import Error500 from '@/components/errors/Error500';
import SolAPIError from '@/error/SolAPIError';

type Props = {
  error: Error | null;
  message404: ReactNode;
};

const ErrorOrChildren = ({ error, message404, children }: PropsWithChildren<Props>) => {
  if (error instanceof SolAPIError && error.is404()) {
    return <Error404 title={message404} />;
  }

  if (error) {
    return <Error500 />;
  }

  return children;
};

export default ErrorOrChildren;
